import React from 'react';

import { NextPageWithLayout } from 'next';

import { InternalLink } from '../../components/Clickables/InternalLink/InternalLink';
import { Container } from '../../components/Container/Container';
import { DownloadAppHorizontalCTA } from '../../components/CTAs/DownloadAppHorizontalCTA/DownloadAppHorizontalCTA';
import { Heading } from '../../components/Heading/Heading';
import { LoadingIndicator } from '../../components/LoadingIndicator/LoadingIndicator';
import { Redirect } from '../../components/Redirect/Redirect';
import { UserDetails } from '../../components/UserDetails/UserDetails';
import { useIsMobileDevice } from '../../helpers/hooks/useIsMobileDevice';
import { useUserInfo } from '../../helpers/hooks/useUserInfo';
import { flowsURLParameters, URLParameters } from '../Authentication/constants';
import { useCurrentURL } from '../../helpers/hooks/useCurrentURL/useCurrentURL';
import { useClientHasRendered } from '../../helpers/hooks';
import { MetaTags } from '../../components/MetaTags/MetaTags';

export const Profile: NextPageWithLayout = () => {
  const { user, isLoggedIn, isLoadingUser, isPremium } = useUserInfo();
  const isMobileDevice = useIsMobileDevice();
  const clientHasRendered = useClientHasRendered();
  const { addParameters } = useCurrentURL();
  const signupLink = addParameters({ [URLParameters.Flow]: flowsURLParameters.signUp });

  if (clientHasRendered && !isLoadingUser && !isLoggedIn) {
    return <Redirect to={signupLink} />;
  }

  return (
    <>
      <Container>
        <MetaTags
          title="Account settings"
          description="View and update your personal data on Fishbrain"
          link="/profile"
        />
        {user ? (
          <div className="pt-8 sm:pt-14">
            <Heading className="my-0 text-center" as="h1">
              Account settings
            </Heading>
            <UserDetails />
            <div className="my-16 text-center">
              {isPremium && (
                <>
                  <p>
                    <Heading variant="2xs" className="text-trench">
                      You are a Fishbrain Pro member
                    </Heading>
                  </p>
                  <InternalLink className="text-base" variant="buttonPro" to="pro/overview">
                    Your Pro membership
                  </InternalLink>
                </>
              )}
            </div>
          </div>
        ) : (
          <LoadingIndicator />
        )}
      </Container>
      {!isMobileDevice && isPremium && (
        <Container>
          <DownloadAppHorizontalCTA className="mb-12" />
        </Container>
      )}
    </>
  );
};
